import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as API from '../api';
import { alertError } from '../utils';

const CreditsContext = createContext();

export const CreditsProvider = ({ children }) => {
  const [credits, setCredits] = useState('0');

  const getCredit = async () => {
    try {
      let result = await API.getCredit();
      setCredits(result.credits);
    } catch (err) {
      alertError(err);
      console.log(err);
    }
  };

  useEffect(() => {
    getCredit();
  }, []);

  return (
    <CreditsContext.Provider value={{ credits, getCredit }}>
      {children}
    </CreditsContext.Provider>
  );
};

CreditsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useCredits = () => {
  return useContext(CreditsContext);
}; 